import React, { useState } from "react";
import {
  Box,
  Backdrop,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  TextField,
  FormHelperText,
} from "@mui/material";
import bkstApi from "../../api";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import CloseIcon from "@mui/icons-material/Close";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";

export default function CancelQuote(props) {
  const { reqId } = useParams();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [nogo, setNogo] = useState("");
  const [note, setNote] = useState("");

  const [loading, setLoading] = useState(false);

  const submit = (e) => {
    e.preventDefault();

    setLoading(true);
    bkstApi
      .put(`/my/quote/${reqId}/cancel`, { status: "closed", nogo, note })
      .then((res) => {
        setOpen(false);
        setLoading(false);
        navigate(0);
      })
      .catch((error) => {
        console.error("Failure");
      });
  };

  return (
    <>
      <Button
        fullWidth
        onClick={() => setOpen(true)}
        color="error"
        variant="outlined"
        disableElevation
        startIcon={<DoNotDisturbIcon />}
      >
        {props.cta || "Cancel Quote"}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true} maxWidth="xs">
        <form onSubmit={submit}>
          <DialogTitle>
            Cancel Quote{" "}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box mb={1}>
              <Typography variant="caption" color="textSecondary">
                Canceling a quote removes it from your dashboard. Active quotes will be expired &
                can no longer be booked by customer.
              </Typography>
            </Box>
            <Box>
              <RadioGroup value={nogo} name="nogo" onChange={(e) => setNogo(e.target.value)}>
                <FormControlLabel
                  value="duplicate"
                  control={<Radio required={true} />}
                  label="Duplicate"
                />
                <FormControlLabel
                  value="rejected"
                  control={<Radio required={true} />}
                  label={`Rejected by customer`}
                />
                <FormControlLabel
                  value="unavailable"
                  control={<Radio required={true} />}
                  label="Unable to fulfill"
                />
              </RadioGroup>
              {nogo === "unavailable" && (
                <Box mt={2}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      value={note}
                      variant="outlined"
                      fullWidth
                      id="note"
                      label="Reason"
                      name="note"
                      multiline
                      rows={2}
                      placeholder="e.g. We're fully booked / We don't make such designs, etc "
                      onChange={(e) => setNote(e.target.value)}
                    />
                    <FormHelperText>
                      Add a short note if you want the customer to be notified
                    </FormHelperText>
                  </FormControl>
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" type="submit" fullWidth>
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {loading && (
        <Backdrop open={loading} style={{ zIndex: "2000", color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
}
